import React from 'react';
import { ArrowRight } from 'lucide-react';
import { outcomes } from '../mock';

const Outcomes = () => {
  return (
    <section className="relative py-16 lg:py-24 bg-[#f4f7fb] overflow-hidden">
      <img
        src="https://www.cisco.com/content/dam/cisco-cdc/site/images/backgrounds/homepage/innovations-bg-glow.png"
        alt=""
        aria-hidden
        className="absolute inset-0 w-full h-full object-cover opacity-70 pointer-events-none"
      />
      <div className="relative max-w-7xl mx-auto px-4 lg:px-8">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#0d274d] max-w-3xl leading-tight">
          Powering outcomes you need to thrive in the AI era
        </h2>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {outcomes.map((o) => (
            <article key={o.title} className="bg-white shadow-sm hover:shadow-xl transition-shadow duration-300 overflow-hidden group">
              <div className="aspect-[16/9] overflow-hidden">
                <img src={o.image} alt={o.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-[#0d274d] mb-3">{o.title}</h3>
                <p className="text-gray-700 text-sm leading-relaxed">{o.description}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-12">
          <a href="#" className="inline-flex items-center gap-2 text-[#0d274d] font-semibold border-b-2 border-[#00bceb] pb-1 hover:text-[#00bceb]">
            Discover why Cisco
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Outcomes;
